Vue.component('faq', {
    delimiters: ['[[', ']]'],
    props: {
      faqId: {
        type: Number,
        default: 0
      }
    },
    data: () => {
      return {
        display: false
      }
    },
    computed: {
    },
    methods: {
      toggle () {
        this.display = !this.display;
      },

    },
    template: `<article class="card card--question" itemscope itemtype="http://schema.org/JobPosting">
    <div class="content" @click="toggle()">
        <h2 class="title" itemprop="name">
            <slot name="title"></slot>
        </h2>
        <button></button>
    </div> 
    <div v-if="display" class="ph-20 pb-20">
        <div class="wswg">
            <slot name="content"></slot>
        </div>
    </div>
</article>`
  })